import React, { useState, useEffect, useRef } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';
import { Trophy, Calendar, MapPin, Users, Ship, Music, Award, Utensils, Star, Volume2, VolumeX, Share2, Send, Loader2, Ticket, Hotel, Wine, ChevronRight, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const CNVT_LOGO = 'https://customer-assets.emergentagent.com/job_ad29ac95-7bd5-469e-9d36-574c8c1f9484/artifacts/bh6nx8y1_CNVT%20LOGO.jpg';
const GOODWILLERS_LOGO = 'https://customer-assets-7cd3h4nn.emergentagent.net/job_ad29ac95-7bd5-469e-9d36-574c8c1f9484/artifacts/86z0xkrd_White%20mens%20polo%20with%20collar%20mockup%20template%20%284%29.png';
const KILIMANJARO_LOGO = 'https://customer-assets.emergentagent.com/job_ad29ac95-7bd5-469e-9d36-574c8c1f9484/artifacts/aee804to_Kilimanjaro%20logo%20sponsor%202.png';
const AFRIC_REMIT_LOGO = 'https://africremit.com/assets/img/src/fric.png';
const BOAT_IMG = 'https://static.prod-images.emergentagent.com/jobs/ad29ac95-7bd5-469e-9d36-574c8c1f9484/images/ac9c2ef170fec87f6bfd233a04d5b55f0770e5d3e72772a2aebe987ac4f03d0d.jpeg';
const GARDEN_IMG = 'https://static.prod-images.emergentagent.com/jobs/ad29ac95-7bd5-469e-9d36-574c8c1f9484/images/ed88aec46ebc13897fb66ee5791d0cdbde96352f479f1bb48758b9cbd7c8059c.jpeg';
const GALA_IMG = 'https://static.prod-images.emergentagent.com/jobs/ad29ac95-7bd5-469e-9d36-574c8c1f9484/images/56e9d6fddbf7686ba2901a557205e1b64be7f11b658ddca47803fbd39d07a5c8.jpeg';
const SOCCER_BALL_BG = 'https://static.prod-images.emergentagent.com/jobs/ad29ac95-7bd5-469e-9d36-574c8c1f9484/images/0ad594707405e407b613bfa4188cbec94ce1e64ed8d4cddef7a0bc3053fb378e.jpeg';
const COCACOLA_LOGO = 'https://static.prod-images.emergentagent.com/jobs/ad29ac95-7bd5-469e-9d36-574c8c1f9484/images/f3e5a4cf38a9f9a9b1d9fe78d39da13edb294b6652a29210dd049d15d8f000c3.jpeg';
const DESJARDINS_LOGO = 'https://www.desjardins.com/ressources/images/logo-n1-desjardins-desktop.svg';
const LASALLE_LOGO = 'https://static.prod-images.emergentagent.com/jobs/ad29ac95-7bd5-469e-9d36-574c8c1f9484/images/ca639c6f79c0ce8bdf0240d1ab487767cee96fbdbf8a84c1cf2bbbfb30da8a66.jpeg';
const SCORECOPILOT_LOGO = '/logo.jpg';
const POOL_IMG = 'https://static.prod-images.emergentagent.com/jobs/ad29ac95-7bd5-469e-9d36-574c8c1f9484/images/674992a2282833293951d42448b52a431b1b9db6b8e174fbeb69ea0dcd92876a.jpeg';
const QF_IMG = 'https://static.prod-images.emergentagent.com/jobs/ad29ac95-7bd5-469e-9d36-574c8c1f9484/images/3d72c2f987b07fc5460be39eea7bebff8627a56d6aee1b9d65dd894e5cf7c51c.jpeg';
const BBQ_IMG = 'https://static.prod-images.emergentagent.com/jobs/ad29ac95-7bd5-469e-9d36-574c8c1f9484/images/3a737687284963d6c26727ff06294a8cdb01a12145006ebe38d33944610da834.jpeg';
const TEAM1_IMG = 'https://static.prod-images.emergentagent.com/jobs/ad29ac95-7bd5-469e-9d36-574c8c1f9484/images/b981f8c44a819951b69a281662305fc39b8595e783bec75bcc7e82b306316457.jpeg';
const TEAM2_IMG = 'https://static.prod-images.emergentagent.com/jobs/ad29ac95-7bd5-469e-9d36-574c8c1f9484/images/83da63f3f7029fb51e05d12545da26fc2a755cc47331b33d467da56d5eaa1d49.jpeg';
const TEAM3_IMG = 'https://customer-assets-7cd3h4nn.emergentagent.net/job_ad29ac95-7bd5-469e-9d36-574c8c1f9484/artifacts/p8u3ljyc_469440208_122210051126226895_8881962099375576899_n.webp';

const RETURNING_TEAMS = [
  { name: 'Goodwillers FC Montreal', badge: 'HOST 2027', badgeColor: 'bg-purple-500' },
  { name: 'Hamilton Community Club', badge: 'Champion', badgeColor: 'bg-yellow-500' },
  { name: 'Spirit FC Calgary', badge: 'Finalist', badgeColor: 'bg-gray-400' },
  { name: 'Goodwill FC Montreal', badge: 'Semi-Final', badgeColor: 'bg-amber-600' },
  { name: 'Diversity FC Edmonton', badge: 'Semi-Final', badgeColor: 'bg-amber-600' },
  { name: 'Camer SC Toronto', badge: 'QF', badgeColor: 'bg-emerald-600' },
  { name: "Friends' CC London", badge: 'QF', badgeColor: 'bg-emerald-600' },
  { name: 'G12 Sport Montreal', badge: 'QF', badgeColor: 'bg-emerald-600' },
  { name: 'Deux Zero Quebec City', badge: 'QF', badgeColor: 'bg-emerald-600' },
  { name: 'Good Boys FC Grand Prairie', badge: 'Returning', badgeColor: 'bg-blue-500' },
  { name: 'GOSEC', badge: 'Returning', badgeColor: 'bg-blue-500' },
  { name: 'Club Sante Soccer Montreal', badge: 'Returning', badgeColor: 'bg-blue-500' },
];
const TBC_TEAMS = Array.from({length: 4}, (_, i) => ({ name: `New Challenger ${i+1}`, badge: 'TBC' }));

const SHARE_TEXT = 'CNVT 2027 is coming! 16 teams, July 1-4, Montreal. Hosted by Goodwillers FC. Boat ride, Gala night, live music & more. A total shutdown!';
const SHARE_URL = 'https://scorecopilot.com';

/* ── Reusable animated section wrapper ── */
function AnimatedSection({ children, className = '', delay = 0 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-60px' });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

/* ── Animated countdown digit with flip effect ── */
function CountdownDigit({ value, label }) {
  return (
    <div className="text-center">
      <motion.div
        key={value}
        initial={{ rotateX: -90, opacity: 0 }}
        animate={{ rotateX: 0, opacity: 1 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
        className="w-16 h-16 md:w-20 md:h-20 bg-white/5 backdrop-blur border border-white/10 rounded-xl flex items-center justify-center"
        style={{ perspective: 400 }}
      >
        <span className="text-2xl md:text-4xl font-mono font-black text-white">{String(value).padStart(2, '0')}</span>
      </motion.div>
      <p className="text-gray-500 text-[10px] uppercase tracking-wider mt-2">{label}</p>
    </div>
  );
}

/* ── Floating particle dots in hero ── */
function HeroParticles() {
  const particles = Array.from({ length: 18 }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    y: Math.random() * 100,
    size: 2 + Math.random() * 4,
    duration: 4 + Math.random() * 6,
    delay: Math.random() * 3,
  }));
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {particles.map(p => (
        <motion.div
          key={p.id}
          className="absolute rounded-full bg-red-400/30"
          style={{ left: `${p.x}%`, top: `${p.y}%`, width: p.size, height: p.size }}
          animate={{ y: [0, -30, 0], opacity: [0.2, 0.7, 0.2] }}
          transition={{ duration: p.duration, delay: p.delay, repeat: Infinity, ease: 'easeInOut' }}
        />
      ))}
    </div>
  );
}

export default function CNVT2027Tab({ teamMap, orgId }) {
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [musicOn, setMusicOn] = useState(false);
  const audioRef = useRef(null);
  const [regForm, setRegForm] = useState({ team_name: '', contact_name: '', email: '', phone: '', city: '' });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const target = new Date('2027-07-01T00:00:00-04:00');
    const tick = () => {
      const d = target - new Date();
      if (d <= 0) return;
      setCountdown({ days: Math.floor(d/864e5), hours: Math.floor(d%864e5/36e5), minutes: Math.floor(d%36e5/6e4), seconds: Math.floor(d%6e4/1e3) });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const toggleMusic = () => {
    if (!audioRef.current) { audioRef.current = new Audio('https://cdn.pixabay.com/audio/2022/10/18/audio_29e10f498e.mp3'); audioRef.current.loop = true; audioRef.current.volume = 0.3; }
    musicOn ? audioRef.current.pause() : audioRef.current.play().catch(() => {});
    setMusicOn(!musicOn);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!regForm.team_name || !regForm.contact_name || !regForm.email) { toast.error('Fill in required fields'); return; }
    setSubmitting(true);
    try {
      const r = await fetch(`${API_URL}/api/team-interest`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...regForm, org_id: orgId }) });
      if (r.ok) { toast.success('Interest registered! We will be in touch.'); setRegForm({ team_name: '', contact_name: '', email: '', phone: '', city: '' }); }
      else toast.error('Failed to submit');
    } catch { toast.error('Network error'); }
    finally { setSubmitting(false); }
  };

  const shareWA = () => window.open(`https://wa.me/?text=${encodeURIComponent(SHARE_TEXT+' '+SHARE_URL)}`, '_blank');
  const shareTT = () => window.open(`https://www.tiktok.com/`, '_blank');
  const shareFB = () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(SHARE_URL)}`, '_blank');
  const copyLink = () => { navigator.clipboard.writeText(SHARE_URL).then(() => toast.success('Link copied!')); };

  /* ── Animation variants ── */
  const stagger = { hidden: {}, visible: { transition: { staggerChildren: 0.08 } } };
  const fadeUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } } };
  const scaleIn = { hidden: { opacity: 0, scale: 0.8 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } } };
  const slideLeft = { hidden: { opacity: 0, x: -60 }, visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } } };
  const slideRight = { hidden: { opacity: 0, x: 60 }, visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } } };

  return (
    <div className="space-y-12 relative">
      {/* Goodwillers watermark background */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden opacity-[0.03]">
        <motion.div
          className="absolute inset-0 flex items-center justify-center"
          animate={{ y: [0, -30, 0, 30, 0], rotate: [0, 2, 0, -2, 0] }}
          transition={{ duration: 20, repeat: Infinity, ease: 'easeInOut' }}
        >
          <img src={GOODWILLERS_LOGO} alt="" className="w-[600px] h-[600px] object-contain" />
        </motion.div>
      </div>

      {/* Music Toggle */}
      <motion.button
        onClick={toggleMusic}
        className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-red-500/90 hover:bg-red-500 text-white flex items-center justify-center shadow-lg shadow-red-500/30"
        data-testid="music-toggle"
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.9 }}
        animate={musicOn ? { boxShadow: ['0 0 15px rgba(239,68,68,0.4)', '0 0 30px rgba(239,68,68,0.7)', '0 0 15px rgba(239,68,68,0.4)'] } : {}}
        transition={musicOn ? { duration: 1.5, repeat: Infinity } : {}}
      >
        {musicOn ? <Volume2 size={20} className="animate-pulse" /> : <VolumeX size={20} />}
      </motion.button>

      {/* ═══════════════ HERO ═══════════════ */}
      <motion.div
        className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#0a0a0a] via-[#1a0a2e] to-[#0a1628] p-8 md:p-12"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      >
        {/* Animated background orbs */}
        <div className="absolute inset-0 overflow-hidden">
          <motion.div
            className="absolute w-96 h-96 bg-red-500/10 rounded-full blur-3xl -top-48 -left-48"
            animate={{ scale: [1, 1.3, 1], opacity: [0.3, 0.6, 0.3] }}
            transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
          />
          <motion.div
            className="absolute w-96 h-96 bg-white/5 rounded-full blur-3xl -bottom-48 -right-48"
            animate={{ scale: [1, 1.4, 1], opacity: [0.2, 0.5, 0.2] }}
            transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut', delay: 1 }}
          />
          <motion.div
            className="absolute w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl top-1/2 left-1/2"
            animate={{ scale: [1, 1.5, 1], x: [-30, 30, -30], opacity: [0.15, 0.4, 0.15] }}
            transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut', delay: 2 }}
          />
          <HeroParticles />
        </div>

        <div className="relative z-10 text-center space-y-6">
          {/* Logos row */}
          <motion.div
            className="flex items-center justify-center gap-6 flex-wrap"
            variants={stagger}
            initial="hidden"
            animate="visible"
          >
            <motion.img
              src={CNVT_LOGO} alt="CNVT"
              className="w-24 h-24 object-contain rounded-xl"
              variants={scaleIn}
              whileHover={{ scale: 1.1, rotate: [0, -5, 5, 0] }}
              transition={{ duration: 0.3 }}
            />
            <motion.div variants={fadeUp}>
              <motion.p
                className="text-red-400 text-xs font-bold uppercase tracking-[0.3em]"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                Presents
              </motion.p>
              <h1 className="text-5xl md:text-7xl font-black text-white tracking-tight">
                CNVT{' '}
                <motion.span
                  className="bg-gradient-to-r from-red-400 via-white to-red-400 bg-clip-text text-transparent"
                  animate={{ backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'] }}
                  transition={{ duration: 4, repeat: Infinity }}
                  style={{ backgroundSize: '200% 200%' }}
                >
                  2027
                </motion.span>
              </h1>
            </motion.div>
            <motion.img
              src={GOODWILLERS_LOGO} alt="CGAM"
              className="w-20 h-20 object-contain rounded-xl border border-white/10 bg-white/5 p-1"
              variants={scaleIn}
              whileHover={{ scale: 1.1, rotate: [0, 5, -5, 0] }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>

          <motion.p
            className="text-gray-400 text-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            Hosted by <span className="text-white font-bold">Goodwillers FC Montreal (C.G.A.M)</span>
          </motion.p>
          <motion.p
            className="text-gray-500 text-sm italic"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            "Our Diversity... Our Strength"
          </motion.p>

          {/* Date / Location / Teams pills */}
          <motion.div
            className="flex items-center justify-center gap-3 text-gray-400 flex-wrap"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.5 }}
          >
            <Calendar size={16} className="text-red-400" /><span>July 1 — 4, 2027</span>
            <span className="text-white/20">|</span><MapPin size={16} className="text-red-400" /><span>Montreal, Canada</span>
            <span className="text-white/20">|</span><Users size={16} className="text-red-400" /><span>16 Teams</span>
          </motion.div>

          {/* COUNTDOWN */}
          <motion.div
            className="relative flex items-center justify-center gap-3 md:gap-6 pt-4"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.8, duration: 0.6 }}
          >
            <motion.img
              src={SOCCER_BALL_BG} alt=""
              className="absolute w-48 h-48 md:w-64 md:h-64 object-contain opacity-20 pointer-events-none"
              animate={{ rotate: [0, 360] }}
              transition={{ duration: 30, repeat: Infinity, ease: 'linear' }}
            />
            <CountdownDigit value={countdown.days} label="Days" />
            <CountdownDigit value={countdown.hours} label="Hours" />
            <CountdownDigit value={countdown.minutes} label="Minutes" />
            <CountdownDigit value={countdown.seconds} label="Seconds" />
          </motion.div>

          <motion.p
            className="text-white/60 text-sm italic"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.0 }}
          >
            "CNVT 2027 plans to be a total shutdown with Goodwillers at the helm"
          </motion.p>

          {/* Social share */}
          <motion.div
            className="flex items-center justify-center gap-3 pt-2"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.1 }}
          >
            <span className="text-gray-500 text-xs uppercase tracking-wider"><Share2 size={12} className="inline mr-1" />Share</span>
            {[
              { fn: shareWA, cls: 'bg-green-500/20 hover:bg-green-500/40 text-green-400', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/></svg> },
              { fn: shareTT, cls: 'bg-pink-500/20 hover:bg-pink-500/40 text-pink-400', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V9.17a8.16 8.16 0 004.76 1.51v-3.4a4.85 4.85 0 01-1-.59z"/></svg> },
              { fn: shareFB, cls: 'bg-blue-600/20 hover:bg-blue-600/40 text-blue-500', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg> },
              { fn: copyLink, cls: 'bg-white/10 hover:bg-white/20 text-gray-400', icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg> },
            ].map((s, i) => (
              <motion.button
                key={i}
                onClick={s.fn}
                className={`w-8 h-8 rounded-full ${s.cls} flex items-center justify-center transition-colors`}
                whileHover={{ scale: 1.2, y: -3 }}
                whileTap={{ scale: 0.85 }}
              >
                {s.icon}
              </motion.button>
            ))}
          </motion.div>
        </div>
      </motion.div>

      {/* ═══════════════ SPONSORS ═══════════════ */}
      <AnimatedSection>
        <div className="bg-[#18181b] rounded-xl border border-white/10 px-6 py-5 overflow-hidden">
          <p className="text-gray-600 text-xs uppercase tracking-widest text-center mb-4">Official Sponsors & Partners</p>
          <motion.div
            className="flex items-center justify-center gap-6 md:gap-10 flex-wrap"
            variants={stagger}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.img src={KILIMANJARO_LOGO} alt="Kilimanjaro" className="h-12 object-contain" variants={scaleIn} whileHover={{ scale: 1.1 }} />
            <motion.div variants={scaleIn} whileHover={{ scale: 1.1 }}>
              <img src={AFRIC_REMIT_LOGO} alt="@fric Remit" className="h-12 object-contain bg-white/90 rounded-lg px-3 py-1" />
            </motion.div>
            <motion.div variants={scaleIn} whileHover={{ scale: 1.1 }}>
              <img src={DESJARDINS_LOGO} alt="Desjardins" className="h-10 object-contain bg-white rounded-lg px-3 py-1.5" />
            </motion.div>
            <motion.div variants={scaleIn} whileHover={{ scale: 1.1 }}>
              <img src={COCACOLA_LOGO} alt="Coca-Cola" className="h-10 object-contain" />
            </motion.div>
            <motion.div variants={scaleIn} whileHover={{ scale: 1.1 }}>
              <img src={LASALLE_LOGO} alt="Ville de LaSalle" className="h-12 object-contain bg-white rounded-lg px-2 py-1" />
            </motion.div>
            <motion.div variants={scaleIn} whileHover={{ scale: 1.1 }} className="flex items-center gap-2 bg-white/10 rounded-lg px-3 py-1.5">
              <img src={SCORECOPILOT_LOGO} alt="ScoreCopilot" className="h-8 w-8 object-contain rounded" />
              <span className="text-white text-xs font-bold">ScoreCopilot</span>
            </motion.div>
          </motion.div>
        </div>
      </AnimatedSection>

      {/* ═══════════════ SCHEDULE ═══════════════ */}
      <AnimatedSection>
        <h2 className="text-white font-heading text-2xl font-bold uppercase mb-6 flex items-center gap-3">
          <motion.div animate={{ rotate: [0, 360] }} transition={{ duration: 8, repeat: Infinity, ease: 'linear' }}>
            <Calendar className="text-red-400" size={24} />
          </motion.div>
          4 Days of Pure Fire
          <img src={CNVT_LOGO} alt="" className="w-8 h-8 object-contain rounded ml-auto" />
        </h2>
      </AnimatedSection>

      {/* Day 1 */}
      <AnimatedSection>
        <ScheduleDay
          gradient="from-red-500 to-white"
          icon={<Ship size={20} className="text-white" />}
          title="July 1 — Canada Day Opening"
          subtitle="A grand opening like no other"
          cards={[
            { img: BOAT_IMG, color: 'text-red-400', label: 'Morning — Boat Ride', title: 'All Red & White Boat Ride Around Montreal Island', desc: 'Set sail in style! A spectacular cruise around the island to kick off CNVT 2027. Dress code: Red & White. Live DJ on board, refreshments, and unforgettable views of the Montreal skyline.', tag: 'LIMITED SEATS', extra: 'Limited seats — grab your ticket now!' },
            { img: TEAM1_IMG, color: 'text-blue-400', label: 'Evening — Meet & Greet', title: 'Welcome Reception & Team Introductions', desc: 'All 16 teams gather for the official welcome ceremony. Meet old rivals, make new friends. Jersey presentations, team photos, and the ceremonial draw for group stages.' },
          ]}
        />
      </AnimatedSection>

      {/* Day 2 */}
      <AnimatedSection delay={0.1}>
        <ScheduleDay
          gradient="from-emerald-500 to-blue-500"
          icon={<Users size={20} className="text-white" />}
          title="July 2 — Group Games + Family Fun"
          subtitle="Where legends are made and families celebrate together"
          cards={[
            { img: POOL_IMG, color: 'text-emerald-400', label: 'All Day — Pool Stage', title: 'Group Stage Matches', desc: '4 pools of 4 teams battle it out across multiple fields. Every goal counts. Every tackle matters. The road to glory starts here.' },
            { img: GARDEN_IMG, color: 'text-blue-400', label: 'Celebration Garden', title: 'Live Music & Family Events', desc: 'Live bands, DJs, food trucks, face painting, kids zone, and cultural performances. The biggest party alongside the beautiful game.' },
            { img: TEAM2_IMG, color: 'text-purple-400', label: 'Artists & Performances', title: 'Top African-Canadian Artists', desc: "Live performances from some of Canada's finest African artists. Afrobeats, reggae, and sounds that'll keep you on your feet all day." },
          ]}
          threeCol
        />
      </AnimatedSection>

      {/* Day 3 */}
      <AnimatedSection delay={0.15}>
        <ScheduleDay
          gradient="from-yellow-500 to-orange-500"
          icon={<Award size={20} className="text-white" />}
          title="July 3 — Knockout Rounds + Gala Night"
          subtitle="The drama intensifies — and the night belongs to champions"
          cards={[
            { img: QF_IMG, color: 'text-orange-400', label: 'Day — Quarter-Finals & Semi-Finals', title: 'Knockout Stage Action', desc: 'Win or go home. 8 teams enter the quarter-finals, only 2 will make the grand final. Penalty shootouts, last-minute goals, and heartbreak — this is where legends are born.' },
            { img: GALA_IMG, color: 'text-yellow-400', label: 'Evening — Grand Gala Party', title: 'Awards, Dinner & Dancing', desc: 'A sumptuous evening to crown the CNVT 2027 champions. Red carpet, trophy ceremony, MVP awards, three-course dinner, live entertainment, and dancing until late. Table reservations available.' },
          ]}
        />
      </AnimatedSection>

      {/* Day 4 */}
      <AnimatedSection delay={0.2}>
        <ScheduleDay
          gradient="from-orange-500 to-red-500"
          icon={<Utensils size={20} className="text-white" />}
          title="July 4 — BBQ & Departure"
          subtitle="One last celebration before we say goodbye"
          cards={[
            { img: BBQ_IMG, color: 'text-red-400', label: 'All Day — Community BBQ & Farewell', title: 'BBQ, Vibes & Memories', desc: 'Fire up the grills! A massive community BBQ with jollof, suya, burgers, and all the favorites. Kids activities, team photo sessions, trophy presentations, and heartfelt farewells. Until next year!' },
            { img: TEAM3_IMG, color: 'text-orange-400', label: 'The Spirit of CNVT', title: 'More Than Just Football', desc: "CNVT brings together African-Canadian communities from coast to coast. It's about unity, culture, brotherhood, and the beautiful game. See you in 2028!" },
          ]}
        />
      </AnimatedSection>

      {/* ═══════════════ 16 TEAMS ═══════════════ */}
      <AnimatedSection>
        <h2 className="text-white font-heading text-2xl font-bold uppercase mb-6 flex items-center gap-3">
          <motion.div animate={{ scale: [1, 1.15, 1] }} transition={{ duration: 2, repeat: Infinity }}>
            <Users className="text-emerald-400" size={24} />
          </motion.div>
          16 Teams — The Biggest CNVT Yet
        </h2>
        <motion.div
          className="grid grid-cols-2 md:grid-cols-4 gap-3"
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-40px' }}
        >
          {RETURNING_TEAMS.map((t, i) => {
            const tm = teamMap ? Object.values(teamMap).find(x => x.name?.toUpperCase() === t.name.toUpperCase()) : null;
            const logo = tm?.logo_data || tm?.logo_url || tm?.logo;
            return (
              <motion.div
                key={i}
                className={`bg-[#18181b] border rounded-lg p-4 text-center group ${i === 0 ? 'border-purple-500/50 ring-1 ring-purple-500/20' : 'border-white/10'}`}
                variants={scaleIn}
                whileHover={{ y: -4, borderColor: 'rgba(16,185,129,0.3)', transition: { duration: 0.2 } }}
              >
                {logo ? (
                  <motion.img src={logo} alt="" className="w-10 h-10 object-contain rounded mx-auto mb-2" whileHover={{ scale: 1.2, rotate: 5 }} />
                ) : (
                  <div className="w-10 h-10 bg-white/5 rounded mx-auto mb-2 flex items-center justify-center">
                    <span className="text-gray-500 text-xs font-bold">{t.name.charAt(0)}</span>
                  </div>
                )}
                <p className="text-white text-xs font-medium truncate">{t.name}</p>
                <span className={`inline-block mt-1 px-2 py-0.5 rounded-full text-[9px] font-bold text-white ${t.badgeColor}`}>{t.badge}</span>
              </motion.div>
            );
          })}
          {TBC_TEAMS.map((t, i) => (
            <motion.div
              key={`t-${i}`}
              className="bg-[#18181b] border border-dashed border-white/20 rounded-lg p-4 text-center"
              variants={scaleIn}
              whileHover={{ y: -4, borderColor: 'rgba(255,255,255,0.4)' }}
            >
              <motion.div
                className="w-10 h-10 bg-white/5 rounded mx-auto mb-2 flex items-center justify-center"
                animate={{ opacity: [0.4, 1, 0.4] }}
                transition={{ duration: 2, repeat: Infinity, delay: i * 0.3 }}
              >
                <span className="text-gray-600 text-lg font-bold">?</span>
              </motion.div>
              <p className="text-gray-500 text-xs font-medium">{t.name}</p>
              <span className="inline-block mt-1 px-2 py-0.5 rounded-full text-[9px] font-bold text-gray-500 bg-gray-800">{t.badge}</span>
            </motion.div>
          ))}
        </motion.div>
      </AnimatedSection>

      {/* ═══════════════ REGISTRATION ═══════════════ */}
      <AnimatedSection>
        <motion.div
          className="bg-gradient-to-r from-red-500/20 to-purple-500/10 border border-red-500/20 rounded-xl p-8"
          whileHover={{ borderColor: 'rgba(239,68,68,0.4)' }}
        >
          <motion.div
            className="flex items-center gap-4 mb-6"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <motion.img
              src={CNVT_LOGO} alt=""
              className="w-12 h-12 object-contain rounded"
              whileHover={{ rotate: 10, scale: 1.1 }}
            />
            <div><h3 className="text-white font-bold text-xl">Register Your Team for CNVT 2027</h3><p className="text-gray-400 text-sm">4 spots available for new challengers</p></div>
          </motion.div>
          <form onSubmit={handleRegister} className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><label className="text-gray-500 text-xs uppercase block mb-1">Team Name *</label><Input value={regForm.team_name} onChange={e => setRegForm(p=>({...p,team_name:e.target.value}))} placeholder="Your team name" className="bg-black/30 border-white/10 text-white" required data-testid="reg-team-name" /></div>
            <div><label className="text-gray-500 text-xs uppercase block mb-1">Contact Person *</label><Input value={regForm.contact_name} onChange={e => setRegForm(p=>({...p,contact_name:e.target.value}))} placeholder="Full name" className="bg-black/30 border-white/10 text-white" required data-testid="reg-contact-name" /></div>
            <div><label className="text-gray-500 text-xs uppercase block mb-1">Email *</label><Input type="email" value={regForm.email} onChange={e => setRegForm(p=>({...p,email:e.target.value}))} placeholder="email@example.com" className="bg-black/30 border-white/10 text-white" required data-testid="reg-email" /></div>
            <div><label className="text-gray-500 text-xs uppercase block mb-1">Phone</label><Input value={regForm.phone} onChange={e => setRegForm(p=>({...p,phone:e.target.value}))} placeholder="+1 (xxx) xxx-xxxx" className="bg-black/30 border-white/10 text-white" data-testid="reg-phone" /></div>
            <div className="md:col-span-2"><label className="text-gray-500 text-xs uppercase block mb-1">City / Province</label><Input value={regForm.city} onChange={e => setRegForm(p=>({...p,city:e.target.value}))} placeholder="e.g. Toronto, ON" className="bg-black/30 border-white/10 text-white" data-testid="reg-city" /></div>
            <div className="md:col-span-2">
              <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                <Button type="submit" disabled={submitting} className="bg-red-500 hover:bg-red-600 text-white font-bold px-8 py-3 text-lg" data-testid="reg-submit-btn">
                  {submitting ? <Loader2 size={18} className="animate-spin mr-2" /> : <Send size={18} className="mr-2" />}
                  {submitting ? 'Submitting...' : 'Register Interest'}
                </Button>
              </motion.div>
            </div>
          </form>
        </motion.div>
      </AnimatedSection>

      {/* ═══════════════ TICKET PACKAGES ═══════════════ */}
      <AnimatedSection>
        <h2 className="text-white font-heading text-2xl font-bold uppercase mb-6 flex items-center gap-3">
          <motion.div animate={{ rotate: [0, -10, 10, 0] }} transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}>
            <Ticket className="text-red-400" size={24} />
          </motion.div>
          Tickets & Packages
        </h2>
        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-4" variants={stagger} initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-40px' }}>
          {[
            { from: 'from-red-500/10', border: 'border-red-500/20', icon: <Ship className="mx-auto text-red-400 mb-3" size={32} />, tag: 'LIMITED SEATS', tagCls: 'bg-red-500', title: 'Boat Ride', desc: 'All Red & White cruise around Montreal Island', cta: 'Grab your ticket now!', ctaColor: 'text-red-400' },
            { from: 'from-yellow-500/10', border: 'border-yellow-500/20', icon: <Wine className="mx-auto text-yellow-400 mb-3" size={32} />, tag: null, tagCls: '', title: 'Gala Night', desc: 'Awards ceremony, dinner, dancing & entertainment', cta: 'Table reservations available', ctaColor: 'text-yellow-400' },
            { from: 'from-purple-500/10', border: 'border-purple-500/20', icon: <Star className="mx-auto text-purple-400 mb-3" size={32} />, tag: 'BEST VALUE', tagCls: 'bg-purple-500', title: 'Combo: Boat + Gala', desc: 'The ultimate CNVT experience — boat cruise + gala party', cta: 'Save with the combo!', ctaColor: 'text-purple-400' },
          ].map((pkg, i) => (
            <motion.div
              key={i}
              className={`bg-gradient-to-b ${pkg.from} to-[#18181b] ${pkg.border} border rounded-xl p-6 text-center relative overflow-hidden`}
              variants={scaleIn}
              whileHover={{ y: -6, scale: 1.02, transition: { duration: 0.25 } }}
            >
              {pkg.tag && (
                <motion.div
                  className={`absolute top-2 right-2 ${pkg.tagCls} text-white text-[9px] font-bold px-2 py-0.5 rounded-full`}
                  animate={{ scale: [1, 1.1, 1] }}
                  transition={{ duration: 1.5, repeat: Infinity }}
                >
                  {pkg.tag}
                </motion.div>
              )}
              {pkg.icon}
              <h3 className="text-white font-bold text-lg">{pkg.title}</h3>
              <p className="text-gray-400 text-sm mt-1">{pkg.desc}</p>
              <p className={`${pkg.ctaColor} text-xs mt-3 font-bold uppercase`}>{pkg.cta}</p>
              <p className="text-gray-600 text-xs mt-2 italic">Ticket info coming soon</p>
            </motion.div>
          ))}
        </motion.div>
        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" variants={stagger} initial="hidden" whileInView="visible" viewport={{ once: true }}>
          <motion.div
            className="bg-[#18181b] border border-white/10 rounded-xl p-5 flex items-center gap-4"
            variants={fadeUp}
            whileHover={{ borderColor: 'rgba(255,255,255,0.25)', x: 4 }}
          >
            <Hotel className="text-blue-400 shrink-0" size={28} />
            <div><h4 className="text-white font-bold">Hotel Packages</h4><p className="text-gray-500 text-sm">Accommodation deals for visiting teams — coming soon</p></div>
            <span className="ml-auto bg-blue-500/20 text-blue-400 text-[9px] font-bold px-2 py-1 rounded">COMING UP</span>
          </motion.div>
          <motion.div
            className="bg-[#18181b] border border-white/10 rounded-xl p-5 flex items-center gap-4"
            variants={fadeUp}
            whileHover={{ borderColor: 'rgba(255,255,255,0.25)', x: 4 }}
          >
            <Ticket className="text-emerald-400 shrink-0" size={28} />
            <div><h4 className="text-white font-bold">Buy Your Tickets</h4><p className="text-gray-500 text-sm">Online ticket sales opening soon — stay tuned!</p></div>
            <span className="ml-auto bg-emerald-500/20 text-emerald-400 text-[9px] font-bold px-2 py-1 rounded">COMING UP</span>
          </motion.div>
        </motion.div>
      </AnimatedSection>

      {/* ═══════════════ PHONE UPDATES SUBSCRIPTION ═══════════════ */}
      <AnimatedSection>
        <PhoneSubscription orgId={orgId} />
      </AnimatedSection>

      {/* ═══════════════ SHARE CTA ═══════════════ */}
      <AnimatedSection>
        <motion.div
          className="bg-[#18181b] border border-white/10 rounded-xl p-6 text-center"
          whileHover={{ borderColor: 'rgba(239,68,68,0.3)' }}
        >
          <motion.div animate={{ y: [0, -6, 0] }} transition={{ duration: 2, repeat: Infinity }}>
            <Share2 className="mx-auto text-red-400 mb-3" size={28} />
          </motion.div>
          <h3 className="text-white font-bold text-lg mb-2">Spread the Word</h3>
          <p className="text-gray-400 text-sm mb-4">Help us make CNVT 2027 the biggest edition yet!</p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            {[
              { fn: shareWA, cls: 'bg-green-600 hover:bg-green-700', label: 'WhatsApp' },
              { fn: shareTT, cls: 'bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700', label: 'TikTok' },
              { fn: shareFB, cls: 'bg-blue-600 hover:bg-blue-700', label: 'Facebook' },
            ].map((s, i) => (
              <motion.div key={i} whileHover={{ scale: 1.05, y: -2 }} whileTap={{ scale: 0.95 }}>
                <Button onClick={s.fn} className={`${s.cls} text-white gap-2`}>{s.label}</Button>
              </motion.div>
            ))}
            <motion.div whileHover={{ scale: 1.05, y: -2 }} whileTap={{ scale: 0.95 }}>
              <Button onClick={copyLink} variant="outline" className="text-gray-300 border-white/20 gap-2">Copy Link</Button>
            </motion.div>
          </div>
        </motion.div>
      </AnimatedSection>

      {/* Footer */}
      <motion.div
        className="flex items-center justify-center gap-6 py-4 opacity-50"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 0.5 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <img src={CNVT_LOGO} alt="CNVT" className="w-12 h-12 object-contain rounded" />
        <span className="text-gray-600 text-xs">Powered by ScoreCopilot</span>
        <img src={GOODWILLERS_LOGO} alt="CGAM" className="w-10 h-10 object-contain rounded" />
      </motion.div>
    </div>
  );
}

/* ═══════════════ Schedule Day Card Sub-component ═══════════════ */
function ScheduleDay({ gradient, icon, title, subtitle, cards, threeCol = false }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-40px' });
  return (
    <div ref={ref} className="mb-6">
      <div className={`bg-gradient-to-r ${gradient} p-[1px] rounded-xl`}>
        <div className="bg-[#0f0f10] rounded-xl p-6">
          <motion.div
            className="flex items-center gap-3 mb-4"
            initial={{ opacity: 0, x: -40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <motion.div
              className={`w-10 h-10 rounded-lg bg-gradient-to-r ${gradient} flex items-center justify-center`}
              whileHover={{ rotate: 15, scale: 1.1 }}
            >
              {icon}
            </motion.div>
            <div>
              <p className="text-white font-bold text-lg">{title}</p>
              <p className="text-gray-400 text-sm">{subtitle}</p>
            </div>
          </motion.div>
          <div className={`grid grid-cols-1 ${threeCol ? 'md:grid-cols-3' : 'md:grid-cols-2'} gap-4`}>
            {cards.map((card, i) => (
              <motion.div
                key={i}
                className="bg-white/5 rounded-lg overflow-hidden group"
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.15 + i * 0.12 }}
                whileHover={{ backgroundColor: 'rgba(255,255,255,0.08)', y: -4 }}
              >
                <div className={`${threeCol ? 'h-40' : 'h-48'} overflow-hidden relative`}>
                  <motion.img
                    src={card.img} alt={card.title}
                    className="w-full h-full object-cover"
                    whileHover={{ scale: 1.08 }}
                    transition={{ duration: 0.5 }}
                  />
                  {card.tag && (
                    <motion.div
                      className="absolute top-2 right-2 bg-red-500 text-white text-[9px] font-bold px-2 py-0.5 rounded-full"
                      animate={{ scale: [1, 1.1, 1] }}
                      transition={{ duration: 1.5, repeat: Infinity }}
                    >
                      {card.tag}
                    </motion.div>
                  )}
                </div>
                <div className="p-4">
                  <p className={`${card.color} text-xs uppercase font-bold`}>{card.label}</p>
                  <p className="text-white font-bold mt-1">{card.title}</p>
                  <p className="text-gray-400 text-sm mt-1">{card.desc}</p>
                  {card.extra && <p className="text-red-400 text-xs mt-2 font-bold">{card.extra}</p>}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════ Phone Subscription Component ═══════════════ */
function PhoneSubscription({ orgId }) {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phone.trim()) { toast.error('Please enter your phone number'); return; }
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/phone-subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: phone.trim(), org_id: orgId })
      });
      if (r.ok) { toast.success('Subscribed! You will receive updates via SMS.'); setPhone(''); }
      else toast.error('Failed to subscribe');
    } catch { toast.error('Network error'); }
    finally { setLoading(false); }
  };

  return (
    <motion.div
      className="bg-gradient-to-r from-emerald-500/10 to-blue-500/10 border border-emerald-500/20 rounded-xl p-6 text-center"
      whileHover={{ borderColor: 'rgba(16,185,129,0.4)' }}
    >
      <motion.div animate={{ scale: [1, 1.1, 1] }} transition={{ duration: 2, repeat: Infinity }}>
        <svg className="mx-auto text-emerald-400 mb-3" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
      </motion.div>
      <h3 className="text-white font-bold text-lg mb-1">Get Updates on Your Phone</h3>
      <p className="text-gray-400 text-sm mb-4">Be the first to know about tickets, schedules, and everything CNVT 2027</p>
      <form onSubmit={handleSubmit} className="flex items-center justify-center gap-3 max-w-md mx-auto">
        <Input
          type="tel"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          placeholder="+1 (xxx) xxx-xxxx"
          className="bg-black/30 border-white/10 text-white flex-1"
          data-testid="phone-subscribe-input"
        />
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <Button type="submit" disabled={loading} className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold" data-testid="phone-subscribe-btn">
            {loading ? <Loader2 size={16} className="animate-spin" /> : 'Subscribe'}
          </Button>
        </motion.div>
      </form>
    </motion.div>
  );
}
